import { Accordion, Col, Form, Row } from 'react-bootstrap';

function AccordionDemo() {
  return (
    <Accordion defaultActiveKey="0">
      <Accordion.Item eventKey="0">
        <Accordion.Header>Accordion Item #1</Accordion.Header>
        <Accordion.Body>
          <Row>
            <Col sm={'auto'}>
              <Form.Label htmlFor="control-1" className="col-form-label">
                承認状態：
              </Form.Label>
            </Col>
            <Col sm={'auto'}>
              <Form.Select id="control-1">
                <option>全て</option>
              </Form.Select>
            </Col>

            <Col sm={'auto'}>
              <Form.Label htmlFor="control-2" className="col-form-label">
                承認状態：
              </Form.Label>
            </Col>
            <Col sm={'auto'}>
              <Form.Select id="control-2">
                <option>全て</option>
              </Form.Select>
            </Col>
          </Row>
        </Accordion.Body>
        <div className="accordion-body accordion-summary">
          <Row>
            <Col sm={'auto'}>
              <Form.Label htmlFor="control-1" className="col-form-label">
                承認状態：
              </Form.Label>
            </Col>
            <Col sm={'auto'}>
              <Form.Label htmlFor="control-1" className="col-form-label">
                全て
              </Form.Label>
            </Col>

            <Col sm={'auto'}>
              <Form.Label htmlFor="control-1" className="col-form-label">
                承認状態：
              </Form.Label>
            </Col>
            <Col sm={'auto'}>
              <Form.Label htmlFor="control-1" className="col-form-label">
                全て
              </Form.Label>
            </Col>
          </Row>
        </div>
      </Accordion.Item>
    </Accordion>
  );
}

export default AccordionDemo;
